package org.chiangmeng.qfast.core.domain.models

enum class AppTheme {
    AMBER,
    OCEAN_BLUE,
    NATURE_GREEN,
    ROYAL_PURPLE,
    MIDNIGHT
}